export default "__VITE_ASSET__DwwM1GYl__"